import { loadMessages, load } from '@progress/kendo-react-intl';

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import jaNumbers from 'cldr-numbers-full/main/ja/numbers.json';
import jaLocalCurrency from 'cldr-numbers-full/main/ja/currencies.json';
import jaCaGregorian from 'cldr-dates-full/main/ja/ca-gregorian.json';
import jaDateFields from 'cldr-dates-full/main/ja/dateFields.json';

import enNumbers from 'cldr-numbers-full/main/en/numbers.json';
import enLocalCurrency from 'cldr-numbers-full/main/en/currencies.json';
import enCaGregorian from 'cldr-dates-full/main/en/ca-gregorian.json';
import enDateFields from 'cldr-dates-full/main/en/dateFields.json';
import zhHantNumbers from 'cldr-numbers-full/main/zh-Hant/numbers.json';
import zhHantLocalCurrency from 'cldr-numbers-full/main/zh-Hant/currencies.json';
import zhHantCaGregorian from 'cldr-dates-full/main/zh-Hant/ca-gregorian.json';
import zhHantDateFields from 'cldr-dates-full/main/zh-Hant/dateFields.json';
import { LOCALE_TYPE } from './locale';
import { messagesInEn } from './en';
import { messagesInJa } from './ja';
import { messagesInZhHant } from './zh-TW';

const messages = {
  [LOCALE_TYPE.JA]: messagesInJa,
  [LOCALE_TYPE.EN]: messagesInEn,
  [LOCALE_TYPE.ZH_HANT]: messagesInZhHant,
};

const dateFormats = {
  [LOCALE_TYPE.JA]: 'yyyy/MM/dd',
  // [LOCALE_TYPE.EN]: 'dd/MMM/yyyy',
  [LOCALE_TYPE.EN]: 'yyyy/MM/dd',
  [LOCALE_TYPE.ZH_HANT]: 'yyyy/MM/dd',
};

const datetimeFormats = {
  [LOCALE_TYPE.JA]: 'yyyy/MM/dd H:mm',
  // [LOCALE_TYPE.EN]: 'dd/MMM/yyyy h:mm a',
  [LOCALE_TYPE.EN]: 'yyyy/MM/dd H:mm',
  [LOCALE_TYPE.ZH_HANT]: 'yyyy/MM/dd H:mm',
};

const setupLocalization = () => {
  load(
    likelySubtags,
    currencyData,
    weekData,
    jaNumbers,
    jaLocalCurrency,
    jaCaGregorian,
    jaDateFields,
    enNumbers,
    enLocalCurrency,
    enCaGregorian,
    enDateFields,
    zhHantNumbers,
    zhHantLocalCurrency,
    zhHantCaGregorian,
    zhHantDateFields,
  );
  loadMessages(messages[LOCALE_TYPE.JA], LOCALE_TYPE.JA);
  loadMessages(messages[LOCALE_TYPE.EN], LOCALE_TYPE.EN);
  loadMessages(messages[LOCALE_TYPE.ZH_HANT], LOCALE_TYPE.ZH_HANT);
};

export {
  setupLocalization,
  messages,
  dateFormats,
  datetimeFormats,
};
